// extracted by mini-css-extract-plugin
export default {"actionlessModal":"styles_actionlessModal__Rtnxm","customSpinner":"styles_customSpinner__qkK7I","fullView":"styles_fullView__y-7IZ","shimmer":"styles_shimmer__oYzLT"};